module.exports = __webpack_public_path__ + "static/media/20210212_213253_003_IMG_2150.6f103fa7.jpg";